import axios from './axios';

/**
 * Hakee TalentPool-hakemukset annetuilla parametreilla
 * @param {Object} params - Hakuparametrit (status, minScore, maxScore, sortBy, limit, page)
 * @returns {Promise<Object>} - Hakemukset ja metatiedot
 */
const getTalentPoolApplications = async (params = {}) => {
	const defaultParams = {
		sortBy: 'createdAt:desc',
		limit: 10,
		page: 1,
	};

	const response = await axios.get('/talentpool', {
		params: { ...defaultParams, ...params },
	});
	return response.data;
};

/**
 * Hakee yksittäisen TalentPool-hakemuksen tiedot
 * @param {string} id - Hakemuksen ID
 * @returns {Promise<Object>} - Hakemuksen tiedot
 */
const getTalentPoolApplication = async (id) => {
	try {
		const response = await axios.get(`/talentpool/${id}`);
		return response.data;
	} catch (error) {
		console.error('Virhe hakemuksen haussa:', error);
		throw error;
	}
};

/**
 * Päivittää TalentPool-hakemuksen tilan
 * @param {string} id - Hakemuksen ID
 * @param {number} status - Uusi tila (1=arvioitu, 2=hyväksytty, 3=hylätty)
 * @returns {Promise<Object>} - Päivitetyn hakemuksen tiedot
 */
const updateTalentPoolApplicationStatus = async (id, status) => {
	try {
		const response = await axios.patch(`/talentpool/${id}`, { status });
		return response.data;
	} catch (error) {
		console.error('Virhe hakemuksen tilan päivityksessä:', error);
		throw error;
	}
};

export {
	getTalentPoolApplications,
	getTalentPoolApplication,
	updateTalentPoolApplicationStatus,
};
